import _invariant      from 'invariant';
import PropTypes       from 'prop-types';
import {
  compose,
  mapProps,
  setDisplayName,
}                      from 'recompose';
import {
  MAP_RESOURCE_COLLECTION_PROP_FILTERS,
  MAP_RESOURCE_COLLECTION_PROP_PAGE,
  MAP_RESOURCE_PROP_API_URL,
}                      from './mapResourceProps.const';
import resourcesConfig from '../../config/resources.config';
import url             from '../../utils/url';


/**
 * @param {string} [resourceName] Name of the resource.
 *
 * @return {function(*=): *}
 */
export const mapResourceCollectionApiUrl = ({resourceName} = {}) => (Component) => {

  const MapResourceCollectionApiUrl = compose(
    setDisplayName('MapResourceCollectionApiUrl'),
    mapProps((props) => {

      const {
              [MAP_RESOURCE_COLLECTION_PROP_PAGE]:    page    = 1,
              [MAP_RESOURCE_COLLECTION_PROP_FILTERS]: filters = {}
            } = props;

      let {[MAP_RESOURCE_PROP_API_URL]: apiUrl = null} = props;

      _invariant(resourcesConfig[resourceName], `Unknown resourceName ('${resourceName}')`);

      apiUrl = url.addQueryParams(apiUrl || resourcesConfig[resourceName].apiPath, {page, ...filters});

      return {...props, apiUrl};

    })
  )(Component);

  MapResourceCollectionApiUrl.propTypes = {
    [MAP_RESOURCE_COLLECTION_PROP_PAGE]:    PropTypes.number,
    [MAP_RESOURCE_COLLECTION_PROP_FILTERS]: PropTypes.object,
  };

  return MapResourceCollectionApiUrl;

};

export const MapResourceCollectionApiUrlPropTypes = {
  [MAP_RESOURCE_PROP_API_URL]: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/resources/mapResourceCollectionApiUrl.js